import { render, staticRenderFns } from "./ExternalGameTabExtra.vue?vue&type=template&id=5a3f1f56&scoped=true&lang=pug"
import script from "./ExternalGameTabExtra.vue?vue&type=script&lang=js"
export * from "./ExternalGameTabExtra.vue?vue&type=script&lang=js"
import style0 from "./ExternalGameTabExtra.vue?vue&type=style&index=0&id=5a3f1f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3f1f56",
  null
  
)

export default component.exports